import React from 'react';
import PropTypes from 'prop-types';

import ModalComponent from 'components/ModalComponent';

const ConfirmEnrollment = ({ onClose, onConfirm }) => (
  <ModalComponent
    buttons={[
      <button type='button' className='btn btn-primary' onClick={onConfirm}>
        Confirm
      </button>
    ]}
    closeText='Cancel'
    onClose={onClose}
    title='Confirm Autopay Setup'
  >
    <p>
      Enabling this setting will require payers to enroll in autopay
      when making a payment and&nbsp;
      <span className='red'>automatically enable autopay for any account with a saved payment method</span>
      .
    </p>
    <p>
      We recommend that you revisit your&nbsp;
      <a href='/web_snippets/autopay_terms' target='_blank'>Autopay Terms & Conditions</a>
      &nbsp;if you enable this setting. They can be modified in&nbsp;
      <a href='/setup/parent_portal_content' target='_blank'>Parent Portal Content Settings</a>
      .
    </p>
  </ModalComponent>
);

ConfirmEnrollment.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};

ConfirmEnrollment.defaultProps = {
  onClose: () => false,
  onConfirm: () => false
};

const ConfirmDisable = ({ onClose, onConfirm }) => (
  <ModalComponent
    buttons={[
      <button type='button' className='btn btn-primary' onClick={onConfirm}>
        Confirm
      </button>
    ]}
    closeText='Cancel'
    onClose={onClose}
    title='Confirm Autopay Setup'
  >
    Enabling this setting will remove the ability for a payer to enroll in autopay and <span className='red'>automatically disable autopay for any account with autopay enabled.</span>
  </ModalComponent>
);

ConfirmDisable.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};

ConfirmDisable.defaultProps = {
  onClose: () => false,
  onConfirm: () => false
};

export {
  ConfirmDisable,
  ConfirmEnrollment
};
